import Swiper from 'swiper/bundle';
export default class {
   constructor() {
      const swiper = new Swiper('.swiper-production', {
         slidesPerView: "auto",
         speed: 800,
         loop: true,
         autoplay: {
            delay: 2000,
         },
      
         pagination: {
            el: ".swiper-pagination",
            type: "fraction",
         },
      
         navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
         },
      
         scrollbar: {
            el: '.swiper-scrollbar',
         },
      });
   }
}